import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Phase 4g.J (Feb 2026) — siehe `input.jsx`. Identisches Auto-Select-Verhalten
 * für vorgefüllte Textareas (z.B. Auftragsbeschreibung, Kundenreklamation).
 */
const Textarea = React.forwardRef(({ className, disableAutoSelect, onFocus, onChange, ...props }, ref) => {
  const interactedRef = React.useRef(false);

  const handleFocus = React.useCallback((e) => {
    if (!disableAutoSelect && !interactedRef.current) {
      const val = e.target.value;
      if (val !== "" && val !== null && val !== undefined) {
        setTimeout(() => {
          try { e.target.select(); } catch { /* unmounted */ }
        }, 0);
      }
    }
    if (typeof onFocus === "function") onFocus(e);
  }, [disableAutoSelect, onFocus]);

  const handleChange = React.useCallback((e) => {
    interactedRef.current = true;
    if (typeof onChange === "function") onChange(e);
  }, [onChange]);

  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onFocus={handleFocus}
      onChange={handleChange}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
